import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import Typography from '@mui/material/Typography';
import zeplinColor from 'theme/Color';
import CustomPopOver from '../CustomPopOver/CustomPopOver';

interface SortPopoverProps {
  anchorEl: HTMLElement | null;
  setAnchorEl: any;
  sortOption: 'asc' | 'desc';
  onSortChange: (value: 'asc' | 'desc') => void;
  label: string;
  ascLabel?: string;
  descLabel?: string;
}

export const SortPopover = ({
  anchorEl,
  setAnchorEl,
  sortOption,
  onSortChange,
  ascLabel = 'A to Z',
  descLabel = 'Z to A',
}: SortPopoverProps) => {
  return (
    <CustomPopOver
      setAnchorEl={setAnchorEl}
      anchorEl={anchorEl}
      id='simple-popover'
      vertical='bottom'
      horizontal='left'
      sx={{ padding: '16px' }}
    >
      <Box
        sx={{
          padding: '16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          height: '100%',
          overflow: 'auto',
        }}
      >
        <RadioGroup
          value={sortOption}
          onChange={(e) => onSortChange(e.target.value as 'asc' | 'desc')}
        >
          <FormControlLabel
            value='asc'
            control={
              <Radio
                size='small'
                sx={{
                  color: zeplinColor.Neutral6,
                  '&.Mui-checked': {
                    color: zeplinColor.BasicBlack,
                  },
                }}
              />
            }
            label={
              <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                {ascLabel}
              </Typography>
            }
          />
          <FormControlLabel
            value='desc'
            control={
              <Radio
                size='small'
                sx={{
                  color: zeplinColor.Neutral6,
                  '&.Mui-checked': {
                    color: zeplinColor.BasicBlack,
                  },
                }}
              />
            }
            label={
              <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                {descLabel}
              </Typography>
            }
          />
        </RadioGroup>
      </Box>
    </CustomPopOver>
  );
};
